import DateTime, { ITimeZone } from '@dealroadshow/uikit-date-time';
import { IDatetime } from '@framework/date-helpers/Datetime';
import { EMPTY_CELL_STATE } from '@/creditflowresearch/ui/common/constants';

interface IDateCellProps {
  cellData: IDatetime,
  cellName?: string,
}

/**
 * Pass a timeZone only for event timestamps that follow the user's selected zone.
 * Business dates (maturity, pricing, settlement, ...) must omit it so they render
 * exactly as stored - US-5365.
 */
const getDateCell = ({ cellData }: IDateCellProps, formatType: string, timeZone?: ITimeZone) => (
  cellData
    ? new DateTime(cellData.dateTime, { timeZone }).format(formatType)
    : EMPTY_CELL_STATE
);

export default getDateCell;
